import { Component, Input } from '@angular/core';
import {
  UntypedFormControl,
  Validators,
  UntypedFormGroup,
  UntypedFormBuilder,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule, formatDate } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import Swal from 'sweetalert2';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { ErrorMessageService } from '@core/service/error-message.service';
import { AuthService } from '@core';
import { Direction } from '@angular/cdk/bidi';
import { FormDialogComponent as ModalAddClient } from '../../../administration/utilisateur-client/form-dialog/form-dialog.component';
import { FormDialogComponent as ModalAddApporteur } from '../../../administration/utilisateur-apporteur/form-dialog/form-dialog.component';
import moment from 'moment';
import { IntegerFormatPipe } from '@core/pipe/integer-format.pipe';
import {
  BsDatepickerConfig,
  BsDatepickerModule,
  BsLocaleService,
} from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';
import { PrintService } from '@core/service/print.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientSearchSelectComponent } from '@shared/components/client-search-select/client-search-select.component';

export interface DialogData {
  id: number;
  action: string;
  item: any;
}
defineLocale('fr', frLocale);

import { MontantInputDirective } from '@shared/directive/montant-input.directive';

@Component({
  selector: 'app-modal-create-reservation',
  imports: [
    MontantInputDirective,
    CommonModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    IntegerFormatPipe,
    BsDatepickerModule,
    ClientSearchSelectComponent,
  ],
  templateUrl: './modal-create-reservation.component.html',
  styleUrl: './modal-create-reservation.component.scss',
})
export class ModalCreateReservationComponent {
  @Input() data: any = {};

  action!: string;
  dialogTitle!: string;

  myDate!: Date;
  minDate!: Date;
  maxDate!: Date;
  datePickerConfig?: Partial<BsDatepickerConfig>;
  client_search_key: any;
  apporteur_search_key: any;
  itemToSave: any = {};
  itemsNationnalite: any = [
    {
      user_nationnalite_name: 'IVOIRIENNE',
      user_nationnalite_id: 'IVOIRIENNE',
    },
    { user_nationnalite_name: 'BURKINABE', user_nationnalite_id: 'BURKINABE' },
    {
      user_nationnalite_name: 'SENEGALAIS',
      user_nationnalite_id: 'SENEGALAIS',
    },
  ];
  itemsNaturePiece: any = [
    {
      nature_piece_name: 'CARTE_IDENTITE',
      user_nature_of_piece: 'CARTE_IDENTITE',
    },
    { nature_piece_name: 'PASSEPORT', user_nature_of_piece: 'PASSEPORT' },
    {
      nature_piece_name: 'PERMIS_CONDUIRE',
      user_nature_of_piece: 'PERMIS_CONDUIRE',
    },
  ];
  createMessage = '';
  editMessage = '';
  deleteMessage = '';
  gender = 'M';
  entity = 'booking';
  isLoading: boolean = false;
  itemsRoom: any;
  endPoint: string = 'reservation';
  title = 'reservation';
  current_service: any = {};

  itemClient: any = {};
  user: any = {};
  itemsService: any = [];
  /** Proposés par le planning : appliqués dès que les listes correspondantes sont chargées. */
  private formuleProposee?: string;
  private chambreProposee?: number;
  itemsChambre: any = [];
  itemsClient: any = [];
  itemsApporteur: any = [];

  imageDisplay: any;
  imageName: string | undefined;
  currentItemImage:
    | {
        fileBase64: any;
        fileName: any;
        extension: any;
        typeDocument: string;
      }
    | undefined;
  loading: boolean | undefined;
  itemsModeReglement: any = [];
  itemsUserCaisse: any;
  clientFidelite: any = null;
  showTimeFields: boolean = false;
  duree_jours: any = 0;
  duree_heures: any = 0;
  itemsTypeReservation: any = [];
  debut_reservation: any;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private restClient: RestClientService,
    private utilities: UtilitiesService,
    private errorMessage: ErrorMessageService,
    private authService: AuthService,
    private modalService: NgbModal,
    private localeService: BsLocaleService,
    private printService: PrintService,
  ) {
    // Set the defaults

    console.log('=== MODAL CONSTRUCTOR ===');

    if (this.action === 'edit') {
      // EDIT MODE
      this.dialogTitle = 'Modifier réservation';

      console.log('Edit mode - itemToSave: ', this.itemToSave);
    }
    this.onSearchClient(this.itemToSave.client_id);
    this.getitemsChambre();
  }

  ngOnInit(): void {
    this.action = this.data?.action;
    this.itemToSave = { ...(this.data?.item || {}) };

    if (this.data.item?.image_url) {
      this.imageDisplay = this.data.item?.image_url;
    }

    if (this.data?.item?.debut_reservation) {
      this.debut_reservation = this.data.item.debut_reservation;
    }
    this.formuleProposee = this.data?.item?.service_codification;
    this.chambreProposee = this.data?.item?.chambre_id;

    if (this.action === 'edit') {
      this.dialogTitle = 'Modifier réservation';
    } else {
      this.dialogTitle = 'Nouvelle réservation';
      this.itemToSave = {};
      // Date choisie dans un calendrier : affichée tout de suite, avant même le choix de la formule.
      if (this.debut_reservation) this.itemToSave.debut_reservation = this.debut_reservation;
    }

    this.user = this.authService.getCurrentUser();
    let text1 = this.gender == 'M' ? 'un' : 'une';
    this.createMessage =
      'Vous êtes sur le point de créer ' + text1 + ' ' + this.title;
    this.editMessage =
      'Vous êtes sur le point de modifier ' + text1 + ' ' + this.title;
    this.deleteMessage =
      'Vous êtes sur le point de supprimer ' + text1 + ' ' + this.title;

    this.getItemsService();
    this.getItemsModeReglement();
    this.getitemsUserCaisse();
    this.getItemsTypeReservation();

    const today = new Date();
    this.myDate = new Date();
    this.minDate = today;

    const future = new Date();
    future.setDate(future.getDate() + 30);
    this.maxDate = future;

    this.datePickerConfig = {
      minDate: this.minDate,
      maxDate: this.maxDate,
      keepDatesOutOfRules: true,
      dateInputFormat: 'DD/MM/YYYY',
    };

    this.localeService.use('fr');
  }

  submit() {
    // Form submission logic
  }

  confirmSaveItem(item: any) {
    if (!this.itemToSave.client_id) {
      this.utilities.showNotification(
        'snackbar-danger',
        'Veuillez renseigner client svp',
        'bottom',
        'center',
      );
      return;
    }

    if (!item.id) {
      item.code = this.generateUniqueString();
    }

    let objToSave = Object.assign({}, item);

    Swal.fire({
      title: this.capitalize(this.title),
      text: objToSave?.id ? this.editMessage : this.createMessage,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.saveItem(objToSave);
      }
    });
  }

  saveItem(item: any) {
    console.info('item to save', item);

    this.isLoading = true;

    let itemAEnregistrer = Object.assign({}, item);

    if (this.currentItemImage && Object.keys(this.currentItemImage).length) {
      itemAEnregistrer.file_data = this.currentItemImage;
    } else {
      delete itemAEnregistrer.file_data;
    }

    itemAEnregistrer.groupe_id = this.user.groupe_id;
    itemAEnregistrer.hotel_id = this.user.hotel_id;
    itemAEnregistrer.duree_jours = this.duree_jours;
    itemAEnregistrer.duree_heures = this.duree_heures;
    itemAEnregistrer.is_ristourne = false;
    itemAEnregistrer.is_validated = true;
    itemAEnregistrer.type_reservation_id = this.itemsTypeReservation.find(
      (itr: any) => itr.codification == 'CHAMBRE',
    )?.id;

    var request = {
      datas: [itemAEnregistrer],
    };

    this.restClient
      .post(
        this.endPoint + '' + (itemAEnregistrer.id ? '/update' : '/create'),
        request,
      )
      .subscribe(
        (res: any) => {
          console.info('result', res);
          this.isLoading = false;

          if (!res['hasError']) {
            this.utilities.showNotification(
              'snackbar-success',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center',
            );

            this.activeModal.close(res.item);

            if (
              this.itemToSave.montant_avance &&
              this.itemToSave.montant_avance > 0
            ) {
              this.getItemsReglementReservation(res.item);
            }
          } else {
            if (res['status'] && res['status']['message']) {
              this.utilities.showNotification(
                'snackbar-danger',
                this.utilities.formatMsgServeur(res['status']['message']),
                'bottom',
                'center',
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.getMessageEndPointNotAvailble(),
            'bottom',
            'center',
          );
          this.loading = false;
        },
      );
  }

  getItemsService() {
    this.itemsChambre = [];

    let request = {
      data: {
        can_reservation: true,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('service/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsService = res['items'];
          const formule = this.formuleProposee
            ? this.itemsService.find((service: any) => service.codification === this.formuleProposee)
            : null;
          if (formule && !this.itemToSave.service_id) {
            this.itemToSave.service_id = formule.id;
            this.onSelectService();
          }
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center',
          );
          this.itemsService = [];
        }
      },
      (err) => {
        this.itemsService = [];
      },
    );
  }

  getItemsReglementReservation(item: any) {
    let request = {
      data: {
        reservation_id: item.reservation_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient
      .post('reglementReservation/getByCriteria', request)
      .subscribe(
        (res: any) => {
          if (res && res['items'] && !res['hasError']) {
            this.imprimerReglement(res.items[0]);
          } else {
            this.utilities.showNotification(
              'snackbar-danger',
              this.utilities.formatMsgServeur(res['status']['message']),
              'bottom',
              'center',
            );
          }
        },
        (err) => {
          // Handle error
        },
      );
  }

  getItemsTypeReservation() {
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('typeReservation/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsTypeReservation = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center',
          );
          this.itemsTypeReservation = [];
        }
      },
      (err) => {
        this.itemsTypeReservation = [];
      },
    );
  }

  imprimerReglement(item: any) {
    let request = {
      data: {
        id: item.id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('pdf/printRecuReservation', request).subscribe(
      (res: any) => {
        if (res && res['item'] && !res['hasError']) {
          this.printService.previewPdf(res['item'].link);
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center',
          );
        }
      },
      (err) => {
        // Handle error
      },
    );
  }

  getItemsModeReglement() {
    let request = {
      data: {},
      index: 0,
      size: 10000,
    };

    this.restClient.post('modeReglement/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsModeReglement = res['items'];
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center',
          );
          this.itemsModeReglement = [];
        }
      },
      (err) => {
        this.itemsModeReglement = [];
      },
    );
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);

      this.imageName = fileName + '.' + extension;

      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentItemImage = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  getitemsChambre() {
    this.itemsChambre = [];

    if (
      (!this.itemToSave.id && !this.itemToSave.service_id) ||
      !this.itemToSave.debut_reservation ||
      !this.itemToSave.fin_reservation
    ) {
      return;
    }

    console.log(
      'this.itemToSave.debut_reservation: ',
      this.itemToSave.debut_reservation,
    );
    console.log(
      'this.itemToSave.fin_reservation: ',
      this.itemToSave.fin_reservation,
    );

    let is_date_fin_after_date_debut = moment(
      this.itemToSave.fin_reservation,
    ).isAfter(this.itemToSave.debut_reservation);

    if (
      this.current_service.codification == 'SEJOUR' &&
      !is_date_fin_after_date_debut
    ) {
      console.log('error: date fin doit etre supérieure à date debut');
      return;
    }

    let request: any = {
      data: {},
      index: 0,
      size: 10000,
    };

    if (!this.itemToSave.id) {
      request.chambre_status = 'AVAILABLE';
      request.service_id = this.itemToSave.service_id;
      request.debut_reservation = this.itemToSave.debut_reservation;
      request.fin_reservation = this.itemToSave.fin_reservation;
    }

    this.restClient.post('chambre/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsChambre = res['items'];
          // La chambre proposée n'est retenue que si elle est libre pour la formule et les dates choisies.
          if (this.chambreProposee && !this.itemToSave.chambre_id
            && this.itemsChambre.some((chambre: any) => chambre.id == this.chambreProposee)) {
            this.itemToSave.chambre_id = this.chambreProposee;
            this.calculatePrice();
          }
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center',
          );
          this.itemsChambre = [];
        }
      },
      (err) => {
        this.itemsChambre = [];
      },
    );
  }

  getitemsUserCaisse() {
    let request = {
      add_caisse_status: true,
      data: {
        user_id: this.user.id,
        hotel_id: this.user.hotel_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('userCaisse/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsUserCaisse = res['items'];
          this.itemsUserCaisse = this.itemsUserCaisse.filter(
            (ic: any) => ic.is_open,
          );
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center',
          );
          this.itemsUserCaisse = [];
        }
      },
      (err) => {
        this.itemsUserCaisse = [];
      },
    );
  }

  onSearchClient(client_id?: any) {
    let request = {
      search_key: this.client_search_key,
      data: {
        id: client_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('client/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsClient = res['items'];
          if (client_id) {
            this.itemToSave.client_id = client_id;
          }
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center',
          );
          this.itemsClient = [];
        }
      },
      (err) => {
        this.itemsClient = [];
      },
    );
  }

  onSearchApporteur(apporteur_id?: any) {
    let request = {
      search_key: this.apporteur_search_key,
      data: {
        id: apporteur_id,
      },
      index: 0,
      size: 10000,
    };

    this.restClient.post('apporteur/getByCriteria', request).subscribe(
      (res: any) => {
        if (res && res['items'] && !res['hasError']) {
          this.itemsApporteur = res['items'];
          if (apporteur_id) {
            this.itemToSave.apporteur_id = apporteur_id;
          }
        } else {
          this.utilities.showNotification(
            'snackbar-danger',
            this.utilities.formatMsgServeur(res['status']['message']),
            'bottom',
            'center',
          );
          this.itemsApporteur = [];
        }
      },
      (err) => {
        this.itemsApporteur = [];
      },
    );
  }

  onGetChambreDisponible() {
    this.itemToSave.chambre_id = null;
    this.getitemsChambre();
  }

  calculatePrice() {
    if (!this.itemToSave.chambre_id) return;

    const selected_chambre = this.itemsChambre.find(
      (ic: any) => ic.id == this.itemToSave.chambre_id,
    );
    if (!selected_chambre) return;

    if (this.current_service?.codification === 'SEJOUR') {
      const dateDebut = moment(this.itemToSave.debut_reservation);
      const dateFin = moment(this.itemToSave.fin_reservation);
      const jours = dateFin.diff(dateDebut, 'days');
      this.duree_jours = jours;
      console.log('duree_jours: ', this.duree_jours);
      this.itemToSave.montant_total =
        this.duree_jours * selected_chambre.montant_service;
    } else {
      // For NUIT and JOURNEE, use the base price
      this.itemToSave.montant_total = selected_chambre.montant_service;
    }
  }

  onSetHeure() {
    // This method should NOT modify fin_reservation date
    // It should only set the hours based on service periodicite
    if (this.current_service?.codification !== 'SEJOUR') {
      this.itemToSave.heure_debut_reservation =
        this.current_service.periodicite_heure_debut;
      this.itemToSave.heure_fin_reservation =
        this.current_service.periodicite_heure_fin;
    }
  }

  openAddClientModal(action: 'add' | 'edit', data?: any) {
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }

    const modalRef = this.modalService.open(ModalAddClient, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
    });
    modalRef.componentInstance.data = { item: data, action };
    modalRef.closed.subscribe((result) => {
      console.log('result: ', result);
      if (result && result.id) {
        this.onSearchClient(result.id);
      }
    });
  }

  openAddApporteurModal(action: 'add' | 'edit', data?: any) {
    let varDirection: Direction;
    if (localStorage.getItem('isRtl') === 'true') {
      varDirection = 'rtl';
    } else {
      varDirection = 'ltr';
    }

    const modalRef = this.modalService.open(ModalAddApporteur, {
      size: 'xl',
      windowClass: 'modal-xxl',
      centered: true,
    });
    modalRef.componentInstance.data = { item: data, action };
    modalRef.closed.subscribe((result) => {
      console.log('result: ', result);
      if (result && result.id) {
        this.onSearchApporteur(result.id);
      }
    });
  }

  generateUniqueString() {
    var timestamp = new Date().getTime();
    var randomNumber = Math.floor(Math.random() * 1000000);
    var uniqueString = timestamp.toString() + randomNumber.toString();
    return uniqueString;
  }

  capitalize(str: any) {
    return str.replace(/^\w/, (c: string) => c.toUpperCase());
  }

  onClientChange(client: any) {
    this.clientFidelite = client?.fidelite ?? null;
  }

  canUseFidelity(): boolean {
    if (!this.clientFidelite) return false;
    return (
      (this.clientFidelite.montant_equivalent ?? 0) >=
      (this.itemToSave.montant_avance ?? 0)
    );
  }

  onCalculateMonnaie() {
    const montantTotal = this.itemToSave.montant_total ?? 0;

    if (this.itemToSave.montant_avance > montantTotal) {
      this.itemToSave.montant_avance = montantTotal;
    }

    if (
      this.itemToSave.montant_avance > 0 &&
      this.itemToSave.montant_recu > 0 &&
      this.itemToSave.montant_recu > this.itemToSave.montant_avance
    ) {
      this.itemToSave.monnaie_rendue =
        this.itemToSave.montant_recu - this.itemToSave.montant_avance;
    }
    if (this.itemToSave.montant_avance > this.itemToSave.montant_recu) {
      this.itemToSave.monnaie_rendue = 0;
    }
  }

  /**
   * Called when user selects a service from dropdown
   * This is the main entry point for setting up dates
   */
  onSelectService() {
    console.log('🔍 STEP 4: onSelectService called');
    console.log('🔍 STEP 4: this.debut_reservation:', this.debut_reservation);
    console.log(
      '🔍 STEP 4: this.itemToSave.debut_reservation:',
      this.itemToSave.debut_reservation,
    );

    this.current_service = this.itemsService.find(
      (is: any) => is.id == this.itemToSave.service_id,
    );

    console.log('🔍 STEP 4: Selected service:', this.current_service);

    // CRITICAL CHECK
    if (this.debut_reservation && !this.itemToSave.debut_reservation) {
      console.log('✅ STEP 4: Using calendar date');
      this.itemToSave.debut_reservation = this.debut_reservation;
    } else if (!this.itemToSave.debut_reservation) {
      console.log('⚠️ STEP 4: Using today date (calendar date not available)');
      this.itemToSave.debut_reservation = moment().toDate();
    } else {
      console.log(
        '🔍 STEP 4: debut_reservation already set:',
        this.itemToSave.debut_reservation,
      );
    }

    console.log(
      '🔍 STEP 4: Final debut_reservation:',
      this.itemToSave.debut_reservation,
    );

    // Set hours
    if (this.current_service?.codification === 'NUIT') {
      this.itemToSave.heure_debut_reservation = '20:00';
      this.itemToSave.heure_fin_reservation = '10:00';
    } else {
      this.itemToSave.heure_debut_reservation = '06:00';
      this.itemToSave.heure_fin_reservation = '06:00';
    }

    console.log('🔍 STEP 4: Before calculateEndDateByServiceType');
    this.calculateEndDateByServiceType();
    console.log('🔍 STEP 4: After calculateEndDateByServiceType');
    console.log('🔍 STEP 4: fin_reservation:', this.itemToSave.fin_reservation);

    this.onSetHeure();
    this.onGetChambreDisponible();
  }

  /**
   * Calculate end date based on service type
   */
  calculateEndDateByServiceType() {
    if (!this.itemToSave.debut_reservation || !this.current_service) {
      console.log(
        '⚠️ Cannot calculate end date - missing start date or service',
      );
      return;
    }

    const startDate = moment(this.itemToSave.debut_reservation);

    console.log(
      'Calculating end date for service:',
      this.current_service.codification,
    );
    console.log('Start date:', startDate.format('YYYY-MM-DD'));

    if (this.current_service.codification === 'SEJOUR') {
      // Stay: start date + 2 days
      this.itemToSave.fin_reservation = startDate
        .clone()
        .add(2, 'days')
        .toDate();
      console.log(
        '✅ SEJOUR: End date = start + 2 days =',
        moment(this.itemToSave.fin_reservation).format('YYYY-MM-DD'),
      );
    } else if (this.current_service.codification === 'NUIT') {
      // Night: start date + 1 day (next day)
      this.itemToSave.fin_reservation = startDate
        .clone()
        .add(1, 'days')
        .toDate();
      console.log(
        '✅ NUIT: End date = start + 1 day =',
        moment(this.itemToSave.fin_reservation).format('YYYY-MM-DD'),
      );
    } else if (this.current_service.codification === 'JOURNEE') {
      // Day: same day
      this.itemToSave.fin_reservation = startDate.clone().toDate();
      console.log(
        '✅ JOURNEE: End date = same day =',
        moment(this.itemToSave.fin_reservation).format('YYYY-MM-DD'),
      );
    }
  }

  /**
   * Called when user manually changes the start date
   */
  onSelectDateDebut(event: any) {
    console.log('📅 Date debut changed:', event);

    // ✅ CRITICAL FIX: Don't process if event is undefined or null
    if (!event) {
      console.log('⚠️ Ignoring undefined/null date debut event');
      return;
    }

    this.itemToSave.debut_reservation = event;
    this.itemToSave.montant_total = 0;

    // Recalculate end date based on current service type
    if (this.current_service && this.current_service.codification) {
      this.calculateEndDateByServiceType();
    }

    // Update hours if needed
    this.onSetHeure();

    // Recalculate price
    this.calculatePrice();
  }

  /**
   * Called when user manually changes the end date
   */
  // onSelectDateFin(event: any) {
  //   console.log('📅 Date fin changed:', event);

  //   this.itemToSave.montant_total = 0;
  //   this.itemToSave.fin_reservation = event;
  //   this.onGetChambreDisponible();
  //   this.calculatePrice();
  // }

  onSelectDateFin(event: any) {
    console.log('📅 Date fin changed:', event);

    // ✅ CRITICAL FIX: Don't process if event is undefined or null
    if (!event) {
      console.log('⚠️ Ignoring undefined/null date fin event');
      return;
    }

    this.itemToSave.montant_total = 0;
    this.itemToSave.fin_reservation = event;
    this.onGetChambreDisponible();
    this.calculatePrice();
  }
}
